{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2021 - 2026                               }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCGeocoding.OpenRouteService;

{$I WEBLib.TMSFNCDefines.inc}

{$IFDEF WEBLIB}
{$DEFINE LCLWEBLIB}
{$ENDIF}
{$IFDEF LCLLIB}
{$DEFINE LCLWEBLIB}
{$ENDIF}

interface

procedure RegisterOpenRouteServiceGeocodingService;
procedure UnRegisterOpenRouteServiceGeocodingService;

implementation

uses
  Classes, Math, DateUtils, Types, SysUtils, WEBLib.TMSFNCGeocoding,
  WEBLib.TMSFNCUtils, WEBLib.TMSFNCTypes, WEBLib.TMSFNCMapsCommonTypes, WEBLib.TMSFNCCloudBase
  {$IFNDEF WEBLIB}
  {$IFNDEF LCLLIB}
  {$HINTS OFF}
  {$IF COMPILERVERSION > 26}
  ,JSON
  {$ELSE}
  ,DBXJSON
  {$IFEND}
  {$HINTS ON}
  {$ELSE}
  ,fpjson
  {$ENDIF}
  {$ENDIF}
  {$IFDEF WEBLIB}
  ,Contnrs, Web, WEBLIB.JSON
  {$ENDIF}
  {$IFNDEF LCLWEBLIB}
  ,Generics.Collections, Generics.Defaults
  {$HINTS OFF}
  {$IF COMPILERVERSION > 22}
  , UITypes
  {$IFEND}
  {$HINTS ON}
  {$ENDIF}
  {$IFDEF LCLLIB}
  ,fgl
  {$ENDIF}
  ;

type
  TTMSFNCGeocodingOpenRouteServiceService = class;

  TTMSFNCGeocodingOpenRouteServiceGeocodingFactoryService = class(TTMSFNCGeocodingFactoryService, ITMSFNCGeocodingServiceOpenRouteService);

  TTMSFNCGeocodingOpenRouteServiceService = class(TTMSFNCGeocodingOpenRouteServiceGeocodingFactoryService)
  protected
    function DoCreateGeocoding: ITMSFNCCustomGeocoding; override;
  end;

type
  TTMSFNCGeocodingOpenRouteServiceGeocoding = class;

  TTMSFNCGeocodingOpenRouteServiceGeocoding = class(TTMSFNCCustomGeocodingInterfacedObject, ITMSFNCCustomGeocoding)
  protected
    function GetIdentifier: string;
    function IsValid: Boolean;
    function GetRequestMethod: TTMSFNCCloudBaseRequestMethod;
    function GetHost: string;
    function GetReverseHost: string;
    function GetPath(AAddress: string): string;
    function GetReversePath(ACoordinate: TTMSFNCMapsCoordinateRec): string;
    function GetQuery(AAddress: string; ALocale: string): string; overload;
    function GetQuery(ACoordinate: TTMSFNCMapsCoordinateRec; ALocale: string): string; overload;
    function GetPostData: string;
    procedure Parse(ARequest: TTMSFNCGeocodingRequest; ARequestResult: string);
    procedure AddHeaders(AHeaders: TTMSFNCCloudBaseRequestHeaders);
    procedure DestroyGeocoding;
  public
    constructor Create;
    destructor Destroy; override;
  end;

var
  GeocodingService: ITMSFNCGeocodingServiceOpenRouteService;

procedure RegisterOpenRouteServiceGeocodingService;
begin
  if not TTMSFNCGeocodingPlatformServices.Current.SupportsPlatformService(ITMSFNCGeocodingServiceOpenRouteService, IInterface(GeocodingService)) then
  begin
    GeocodingService := TTMSFNCGeocodingOpenRouteServiceService.Create;
    TTMSFNCGeocodingPlatformServices.Current.AddPlatformService(ITMSFNCGeocodingServiceOpenRouteService, GeocodingService);
  end;
end;

procedure UnregisterOpenRouteServiceGeocodingService;
begin
  TTMSFNCGeocodingPlatformServices.Current.RemovePlatformService(ITMSFNCGeocodingServiceOpenRouteService);
end;

{ TTMSFNCGeocodingOpenRouteServiceService }

function TTMSFNCGeocodingOpenRouteServiceService.DoCreateGeocoding: ITMSFNCCustomGeocoding;
begin
  Result := TTMSFNCGeocodingOpenRouteServiceGeocoding.Create;
end;

procedure TTMSFNCGeocodingOpenRouteServiceGeocoding.AddHeaders(
  AHeaders: TTMSFNCCloudBaseRequestHeaders);
begin

end;

constructor TTMSFNCGeocodingOpenRouteServiceGeocoding.Create;
begin
  inherited;
end;

destructor TTMSFNCGeocodingOpenRouteServiceGeocoding.Destroy;
begin
  inherited;
end;

procedure TTMSFNCGeocodingOpenRouteServiceGeocoding.DestroyGeocoding;
begin
  GeocodingService.DestroyGeocoding(Self);
end;

function TTMSFNCGeocodingOpenRouteServiceGeocoding.GetHost: string;
begin
  Result := 'https://api.openrouteservice.org';
end;

function TTMSFNCGeocodingOpenRouteServiceGeocoding.GetReverseHost: string;
begin
  Result := GetHost;
end;

function TTMSFNCGeocodingOpenRouteServiceGeocoding.GetIdentifier: string;
begin
  Result := 'OpenRouteService';
end;

function TTMSFNCGeocodingOpenRouteServiceGeocoding.GetPath(AAddress: string): string;
begin
  Result := '/geocode/search';
end;

function TTMSFNCGeocodingOpenRouteServiceGeocoding.GetReversePath(ACoordinate: TTMSFNCMapsCoordinateRec): string;
begin
  Result := '/geocode/reverse';
end;

function TTMSFNCGeocodingOpenRouteServiceGeocoding.GetPostData: string;
begin
  Result := '';
end;

function TTMSFNCGeocodingOpenRouteServiceGeocoding.GetQuery(
  ACoordinate: TTMSFNCMapsCoordinateRec; ALocale: string): string;
begin
  Result := 'api_key=' + GeocodingProperties.GetAPIKey
    + '&point.lat=' + TTMSFNCUtils.FloatToStrDot(ACoordinate.Latitude)
    + '&point.lon=' + TTMSFNCUtils.FloatToStrDot(ACoordinate.Longitude);
end;

function TTMSFNCGeocodingOpenRouteServiceGeocoding.GetQuery(AAddress: string; ALocale: string): string;
begin
  Result := 'api_key=' + GeocodingProperties.GetAPIKey
    + '&text=' + AAddress;
end;

function TTMSFNCGeocodingOpenRouteServiceGeocoding.GetRequestMethod: TTMSFNCCloudBaseRequestMethod;
begin
  Result := rmGet;
end;

function TTMSFNCGeocodingOpenRouteServiceGeocoding.IsValid: Boolean;
begin
  Result := GeocodingProperties.GetAPIKey <> '';
end;

procedure TTMSFNCGeocodingOpenRouteServiceGeocoding.Parse(ARequest: TTMSFNCGeocodingRequest; ARequestResult: string);
var
  d: TTMSFNCGeocodingItems;
  di: TTMSFNCGeocodingItem;

  o, jo, joar: TJSONValue;
  jar, jab: TJSONArray;
  i, j: Integer;
  ob, oc: TJSONObject;
begin
  if Assigned(GeocodingProperties) then
  begin
    d := ARequest.Items;

    if Assigned(d) then
    begin
      if ARequestResult <> '' then
      begin
        o := TTMSFNCUtils.ParseJSON(ARequestResult);
        if Assigned(o) then
        begin
          try
            ARequest.ErrorMessage := TTMSFNCUtils.GetJSONProp(o, 'error');
            if ARequest.ErrorMessage <> '' then
              ARequest.Status := 'error';

            jar := TTMSFNCUtils.GetJSONValue(o, 'features') as TJSONArray;
            if Assigned(jar) then
            begin
              for i := 0 to TTMSFNCUtils.GetJSONArraySize(jar) - 1 do
              begin
                jo := TTMSFNCUtils.GetJSONArrayItem(jar, i);

                di := d.Add;

                oc := TTMSFNCUtils.GetJSONValue(jo, 'properties') as TJSONObject;
                if Assigned(oc) then
                begin
                  di.Address := TTMSFNCUtils.GetJSONProp(oc, 'label');
                  di.Street := TTMSFNCUtils.GetJSONProp(oc, 'street');
                  if di.Street = '' then
                    di.Street := TTMSFNCUtils.GetJSONProp(oc, 'name');
                  di.PostalCode := TTMSFNCUtils.GetJSONProp(oc, 'postalcode');
                  di.City := TTMSFNCUtils.GetJSONProp(oc, 'localadmin');
                  di.Region := TTMSFNCUtils.GetJSONProp(oc, 'county');
                  di.RegionCode := TTMSFNCUtils.GetJSONProp(oc, 'county_a');
                  di.County := TTMSFNCUtils.GetJSONProp(oc, 'county');
                  di.Province := TTMSFNCUtils.GetJSONProp(oc, 'region');
                  di.ProvinceCode := TTMSFNCUtils.GetJSONProp(oc, 'region_a');
                  di.Country := TTMSFNCUtils.GetJSONProp(oc, 'country');
                  di.CountryCode := TTMSFNCUtils.GetJSONProp(oc, 'country_a');
                end;

                ob := TTMSFNCUtils.GetJSONValue(jo, 'geometry') as TJSONObject;
                if Assigned(ob) then
                begin
                  jab := TTMSFNCUtils.GetJSONValue(ob, 'coordinates') as TJSONArray;
                  if Assigned(jar) then
                  begin
                    for j := 0 to TTMSFNCUtils.GetJSONArraySize(jab) - 1 do
                    begin
                      joar := TTMSFNCUtils.GetJSONArrayItem(jab, j);
                        if j = 0 then
                          di.Coordinate.Longitude := TTMSFNCUtils.StrToFloatDot(joar.Value);
                        if j = 1 then
                          di.Coordinate.Latitude := TTMSFNCUtils.StrToFloatDot(joar.Value);
                    end;
                  end;
                end;
              end;
            end;
          finally
            o.Free;
          end;
        end;
      end;
    end;
  end;
end;

end.
